module.exports = __webpack_public_path__ + "static/Thumb_Server_Room_Under_the_Water_comp-6a97c3a46a2b4a27407be0d3746adfd2.png";